import createReminderDisplayString from './createReminderDisplayString';
import ReminderOptionType from '../helpers/ReminderOptionType';
import { createLowercaseFormatter } from 'owa-duration-formatter/lib/lowercase';
import { nonAllReminderDropdownOptions } from './reminderDropdownOptions';
import updateReminderStrings from './updateReminderStrings';
import isSelectedReminderPresent from './isSelectedReminderPresent';
import generateReminderDropdownOptions from './generateReminderDropdownOptions';
import addCustomReminderOption from './addCustomReminderOption';

/**
 * Returns the list of reminder drop down options needed for the events and invitation setting.
 * If a custom reminder exists on the event, it is added to the list.
 */
export default function createReminderDropdownOptionsForSettings(
    selectedReminderTimeInMinutes: number,
    createReminderDisplayStringFunction?: typeof createReminderDisplayString
): ReminderOptionType[] {
    if (!createReminderDisplayStringFunction) {
        createReminderDisplayStringFunction = createReminderDisplayString;
    }

    return createReminderDropdownOptionsHelperForSettings(
        selectedReminderTimeInMinutes,
        createReminderDisplayStringFunction
    );
}

/**
 * Updates the reminder dropdown options so no options are available larger than the amount of time before start of event.
 * If a custom reminder exists on the event, it is added to the list.
 * @param Date start
 * @param boolean isAllDay
 * @param boolean isRecurringMaster
 * @param number selectedReminderTimeInMinutes
 * @param typeof createReminderDisplayString createReminderDisplayStringFunction
 */
function createReminderDropdownOptionsHelperForSettings(
    selectedReminderTimeInMinutes: number,
    createReminderDisplayStringFunction: typeof createReminderDisplayString
): ReminderOptionType[] {
    if (selectedReminderTimeInMinutes == null || selectedReminderTimeInMinutes == undefined) {
        selectedReminderTimeInMinutes = -1;
    }

    // This is needed to update the text of ReminderOptionType with localized strings.
    let lowercaseFormatter = createLowercaseFormatter();
    updateReminderStrings(nonAllReminderDropdownOptions, false, lowercaseFormatter);

    let maxReminderTime =
        nonAllReminderDropdownOptions[nonAllReminderDropdownOptions.length - 1].key;
    let reminderDropdownOptions = generateReminderDropdownOptions(
        nonAllReminderDropdownOptions,
        maxReminderTime
    );
    let foundSelectedReminder = isSelectedReminderPresent(
        reminderDropdownOptions,
        selectedReminderTimeInMinutes
    );

    // Next, add the selected reminder if it wasn't already in the list.
    if (!foundSelectedReminder && selectedReminderTimeInMinutes != -1) {
        addCustomReminderOption(
            selectedReminderTimeInMinutes,
            false,
            reminderDropdownOptions,
            createReminderDisplayStringFunction
        );
    }

    return reminderDropdownOptions;
}
